import MyVfcCode from './vfcCode.vue'

const VfcCode = {
    install: function (Vue) {
        Vue.component('my-vfccode', MyVfcCode)
    }
}

export default VfcCode
